module.exports = __webpack_public_path__ + "img/alram.1ce1ddfa.gif";